var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.33333 4.33333C7.33333 3.96514 7.63181 3.66667 8 3.66667C8.36819 3.66667 8.66667 3.96514 8.66667 4.33333V7.33333H11.6667C12.0349 7.33333 12.3333 7.63181 12.3333 8C12.3333 8.36819 12.0349 8.66667 11.6667 8.66667H8.66667V11.6667C8.66667 12.0349 8.36819 12.3333 8 12.3333C7.63181 12.3333 7.33333 12.0349 7.33333 11.6667V8.66667H4.33333C3.96514 8.66667 3.66667 8.36819 3.66667 8C3.66667 7.63181 3.96514 7.33333 4.33333 7.33333H7.33333V4.33333Z",
    fill: "#003CCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.a09dc9b4f7717963c3b563c8ec9cf577.svg";
export { ForwardRef as ReactComponent };